module.exports = __webpack_public_path__ + "euro-coin.31477e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/coins/euro-coin.png
// module id = 558
// module chunks = 0